import useAppointmentStore from '@/store/AppointmentStore';
import { getSearchedDestinationLabel } from '@/utils/formatSearchedDestination';

const useSearchedDestinationLabel = (): string =>
  useAppointmentStore((state) =>
    getSearchedDestinationLabel(state.searchedDestination),
  );

export default useSearchedDestinationLabel;
